module.exports = __webpack_public_path__ + "img/lightbulb-white.8aa0af3e.svg";